import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import { geoAzimuthalEquidistant } from 'd3-geo';

import Points from '../points';
import Cables from '../cables';
import Lines from '../lines';

const EventCont = styled.svg`
	position: fixed;
	top: 0px;
	left: 0px;
	z-index: 10;
	${(props) =>
		!props.mobile &&
		css`
			cursor: grab;
			margin-left: 180px;
			width: calc(100vw - 180px);
		`};
`;

const Map = ({ f, state, mobile }) => {
	const zoom = state.level * state.zoomInit;
	const [etarget, setEtarget] = useState('none');
	const [startPoint, setStartPoint] = useState({ x: 0, y: 0 });
	const [endPoint, setEndPoint] = useState({ x: 0, y: 0 });

	const moveDelta = (dx, dy) => {
		let a = state.dPos[0] + dx / (zoom / 100);
		let b = state.dPos[1] - dy / (zoom / 100);

		if (zoom > 1000) {
			a = a < -130 ? -130 : a > 18 ? 18 : a;
			b = b < -50 ? -50 : b > 54 ? 54 : b;
		} else {
			a = a < -115 ? -115 : a > 10 ? 10 : a;
			b = b < -40 ? -40 : b > 45 ? 45 : b;
		}

		f.move([a, b]);
	};

	const p = () => {
		return geoAzimuthalEquidistant()
			.scale(zoom)
			.rotate([-state.pos[0], -state.pos[1]])
			.translate([state.size.width / 2, state.size.height / 2]);
	};
	const layerNow = state.selected.layer;

	const handleDown = (e) => {
		setEtarget(e.target.id);
		setStartPoint({ x: e.screenX, y: e.screenY });
	};

	const handleDownTouch = (e) => {
		setEtarget('none');
		setStartPoint({ x: e.touches[0].screenX, y: e.touches[0].screenY });
	};

	const handleMoveTouch = (e) => {
		setEndPoint({ x: e.touches[0].screenX, y: e.touches[0].screenY });
	};

	const handleUp = (e) => {
		const dx = startPoint.x - e.screenX;
		const dy = startPoint.y - e.screenY;
		const type = e.target.nodeName;
		Math.abs(dx) > 50 || Math.abs(dy) > 50
			? moveDelta(dx, dy)
			: type !== 'svg' && e.target.id === etarget && f.urlTo('', type === 'circle' ? 'location' : 'cable', e.target.id);
	};

	const handleUpTouch = (e) => {
		const dx = startPoint.x - endPoint.x;
		const dy = startPoint.y - endPoint.y;
		moveDelta(dx, dy);
	};

	const map = state.move ? (
		undefined
	) : (
		<EventCont
			id="Map-content"
			width={state.size.width}
			height={state.size.height}
			mobile={mobile}
			onMouseDown={handleDown}
			onMouseUp={handleUp}
			onTouchStart={handleDownTouch}
			onTouchMove={handleMoveTouch}
			onTouchEnd={handleUpTouch}
		>
			<g className="map-elements">
				{layerNow === 'network' || layerNow === 'capacity' ? (
					<Lines name="fibre" layer={layerNow} p={p} mobile={mobile} />
				) : (
					undefined
				)}
				{layerNow === 'ip' && <Lines name="ip" layer={layerNow} p={p} mobile={mobile} />}
				{layerNow === 'network' && state.selected.type !== 'cables' && (
					<Lines name="fibreExt" layer={layerNow} p={p} mobile={mobile} />
				)}

				{layerNow === 'network' || layerNow === 'cables' || layerNow === 'capacity' ? (
					<g className="cables">
						{<Cables p={p} selected={state.selected} cableHover={f.cableHover} mobile={mobile} />}
					</g>
				) : (
					undefined
				)}
				<Points p={p} selected={state.selected} size={state.size} z={zoom} />
			</g>
		</EventCont>
	);
	return <>{map}</>;
};
export default Map;
